import styles from './index.module.scss'
import { Switch, Popover } from 'antd';
import { GenerateContext } from "../../../hooks/GenerateContext"
import { useContext } from "react"
import { QuestionCircleOutlined } from '@ant-design/icons';

const SkinRefine = (props) => {
    const {
        skinRefine, setSkinRefine
    } = useContext(GenerateContext)

    return (
        <div className={styles.skinRefine}>
            <div className={styles.title}>人像皮肤优化
                <Popover content={'开启后人像肤质细节会更精致，但将增加生成时间'}>
                    <QuestionCircleOutlined style={{ marginLeft: 8, cursor: 'pointer' }} />
                </Popover>
            </div>
            <div className={styles.switch}>
                <Switch style={{ marginRight: 8 }}
                    checked={skinRefine === 1 ? true : false}
                    onChange={() => setSkinRefine(skinRefine === 1 ? 0 : 1)} />{skinRefine === 1 ? '开启' : '关闭'}
            </div>
        </div>
    )
}


export default SkinRefine